export var DP_DETAILS = "DP_DETAILS";
